import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styles from './styles.module.scss';
import PropTypes from 'prop-types';

class UnytedModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { showModal: true };
  }

  cancel() {
    if (this.props.onCancel) {
      this.props.onCancel();
    } else if (this.props.onClose) {
      this.props.onClose();
    }
  }

  accept() {
    if (this.props.onAccept) {
      this.props.onAccept();
    } else {
      this.cancel();
    }
  };

  render() {
    const {
      size,
      heading,
      children,
      onCancel,
      onAccept,
      cancelBtnText,
      closeBtnText,
      disabled,
      noFooter,
      centered,
      headerTag,
      buttonClass,
      bodyClass,
      scrollable,
      headerClass,
      customCloseButton,
      customFooter,
    } = this.props;
    return (
      <Modal
        className={styles.modalFadeIn}
        isOpen={this.state.showModal}
        size={size}
        backdropClassName={styles.backdrop}
        toggle={this.cancel.bind(this)}
        centered={centered}
        scrollable={scrollable}
      >
        <ModalHeader
          tag={headerTag}
          toggle={this.cancel.bind(this)}
          className={headerClass}
          {...(customCloseButton && { close: customCloseButton })}
        >
          {heading}
        </ModalHeader>
        {children && <ModalBody className={bodyClass}>{children}</ModalBody>}
        {!noFooter && (
          <ModalFooter className="d-flex">
            {onCancel && (
              <button
                className={`${buttonClass} outline red`}
                onClick={this.cancel.bind(this)}
              >
                {cancelBtnText || 'Cancel'}
              </button>
            )}
            {((onCancel && onAccept) || !onCancel) && (
              <button
                className={`${styles.closeBtn} ${buttonClass} outline-padded blue`}
                onClick={this.accept.bind(this)}
                disabled={disabled}
              >
                {closeBtnText || 'EXIT'}
              </button>
            )}
          </ModalFooter>
        )}
        {customFooter && (
          <ModalFooter className="p-0">{customFooter}</ModalFooter>
        )}
      </Modal>
    );
  }
}

UnytedModal.propTypes = {
  size: PropTypes.string,
  onCancel: PropTypes.func,
  onAccept: PropTypes.func,
  heading: PropTypes.string,
  cancelBtnText: PropTypes.string,
  closeBtnText: PropTypes.string,
  onClose: PropTypes.func,
  centered: PropTypes.bool,
};

export default UnytedModal;
